import React from "react";

const Footer = () => {
  return (
    <div>
      <div className="contaier">
        <div className="row ml-1">
          <div className="col-lg-1"></div>
          <div className="col-lg-5">
            <h3 className="h3">Recommended services for you</h3>
            <h5>Recruiter Connection</h5>
            <li className="ul">Expand your reach amongst recruiters</li>
            <li className="ul">
              Search our database of recruiters and contact recruiters who hire
              in your domain/industry.
            </li>
          </div>
          <div className="col-lg-5">
            <h5>Jobs on Mail and SMS</h5>
            <ul className="ul">
              Know about job openings in real time and be an early applicant Let
              our experts send the best jobs for you on <b>info@pabjobs.com</b> and sms. Be an
              early applicant and never miss out on any relevant job opening
            </ul>
          </div>
          <div className="col-lg-1"></div>
        </div>
        <div className="textresume_information pl-5 mt-5 p-4">
          <h4>Delivery Information</h4>
          <p className="p1">
            If not availed with resume writing, these services will be processed
            8 working days after we receive your updated resume. In case we do
            not receive a response in 7 days, we will use your last updated
            pabjobs resume. However, if you avail these services with resume
            writing, these services will be processed within 8 working days
            after you approve your final resume.
          </p>
        </div>
        {/* <div className="row textresume_footer">
          <div className="col-lg-1 col-md-1 col-sm-1"></div>
          <div className="col-lg-2 col-md-2 col-sm-2">
            <ul>Resume Writing</ul>
            <ul>Text Resume</ul>
            <ul>Visual Resume</ul>
            <ul>Resume Critique</ul>
            <ul>Resume Quality Score</ul>
            <ul>Resume Samples</ul>
            <ul>Cover Letter Samples</ul>
            <ul>Job Letter Samples</ul>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2">
            <ul>Recruiter Reach</ul>
            <ul>Resume Display</ul>
            <ul>Recruiter Connection</ul>
            <ul>Priority Appilcant</ul>
            <ul>Certification Highlighter</ul>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2">
            <ul>Enhance Profile</ul>
            <ul>Learning & Certification</ul>
            <ul>Onilne Aptitude Test</ul>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2">
            <ul>Find Jobs</ul>
            <ul>Jobs4U</ul>
            <ul>Value Pack</ul>
          </div>
          <div className="col-lg-2 col-md-2 col-sm-2">
            <ul></ul>
            <ul>Provide your feedback</ul>
            <ul>Sitemap</ul>
            <ul>customer support service</ul>
            <ul>Fastforward Outbound Numbers</ul>
          </div>
          <div className="col-lg-1 col-md-1 col-sm-1"></div>
        </div> */}
        {/* <div>
          <h5 className="disclaimer ml-5">Disclaimer</h5>

          <p className="p5 ml-5">
            While Naukri FastForward services have helped many customers over
            the years, we do not guarantee any interview calls or assure any job
            offers with any of our services. The services associated with
            NaukriFastforward are only provided through the website Naukri.com.
            You are advised to be cautious of calls/emails asking for payment
            from other web sites that claim to offer similar services under the
            name of Naukri.com. We have no associates/agents other than the
            partner sites that have been specifically named on the homepage of
            the website Naukri.com. We also recommend that you visit Terms and
            Conditions and Privacy Policy Naukri FastForward may also contact
            the User through SMS, internet-based messaging applications like
            WhatsApp, voice call, e-mail for any pending or failed transactions,
            to assist user in concluding the purchase of Naukri FastForward
            services.The User hereby unconditionally consents that such
            communications via SMS, internet-based messaging applications like
            WhatsApp, voice call, email or any other mode by Naukri FastForward
            are: 1) upon the request and authorization of the User; 2)
            'transactional' and not an 'unsolicited commercial communication' as
            per the guidelines of Telecom Regulation Authority of India (TRAI),
            and 3) in compliance with the relevant guidelines of TRAI or such
            other authority in India and abroad. The User will indemnify Naukri
            FastForward against all types of losses and damages incurred by
            Naukri FastForward due to any action taken by TRAI, Access Providers
            (as per TRAI regulations) or any other authority due to any
            erroneous complaint raised by the User on Naukri FastForward with
            respect to the communications mentioned above or due to a wrong
            number or email id being provided by the User for any reason
            whatsoever. Partner Sites
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default Footer;
